























import { Prop, Component, Vue } from 'vue-property-decorator'
import { BranchTarget } from '@/api/model/branch-target'
import { BranchTargetAPI } from '@/api/backend-client'
import { escapeHtml } from '@/helpers/html'

@Component
export default class TargetsEdit extends Vue {
    @Prop({ required: true }) readonly target: BranchTarget|null
    submitting: boolean = false

    async editTarget(): Promise<void> {
        try {
            this.submitting = true

            await BranchTargetAPI.update(this.target.id, this.target)
            this.onUpdated(this.target)

        } catch (error) {
            this.$notify({
                type: 'error',
                title: 'Foutmelding',
                text: escapeHtml(error.message),
            })

        } finally {
            this.submitting = false
        }
    }

    onUpdated(target: BranchTarget): void {
        this.$emit('updated', target)
    }

    onCancel(): void {
        this.$emit('cancel')
    }
}
